module.exports = __webpack_public_path__ + "assets/icon-file.abb9f9fc.svg";